import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__grid">
          <div className="footer__col">
            <p className="footer__col-title">Legal</p>
            <ul className="footer__links">
              <li><span className="footer__link-btn" onClick={() => navigate("/refund-policy")}>Refund Policy</span></li>
              <li><span className="footer__link-btn" onClick={() => navigate("/privacy-policy")}>Privacy Policy</span></li>
              <li><span className="footer__link-btn" onClick={() => navigate("/terms-and-conditions")}>Terms &amp; Conditions</span></li>
            </ul>
          </div>
          <div className="footer__col">
            <p className="footer__col-title">Shop</p>
            <ul className="footer__links">
              <li><a href="/shop/reup-vault">ReUp Vault</a></li>
              <li><a href="/shop/fresh-farm-produce">Fresh Farm Produce</a></li>
              <li><a href="/shop/meat-and-livestock">Meat &amp; Livestock</a></li>
              <li><a href="/shop/grains-and-staples">Grains &amp; Staples</a></li>
            </ul>
          </div>
          <div className="footer__col">
            <p className="footer__col-title">More</p>
            <ul className="footer__links">
              <li><a href="/shop/snacks-and-confectionery">Snacks &amp; Confectionery</a></li>
              <li><a href="/shop/dairy-and-eggs">Dairy &amp; Eggs</a></li>
              <li><a href="/shop/beverages">Beverages</a></li>
              <li><a href="/shop/canned-and-packaged-foods">Canned &amp; Packaged Foods</a></li>
            </ul>
          </div>
          <div className="footer__col">
            <p className="footer__col-title">Products</p>
            <ul className="footer__links">
              <li><a href="/shop/condiments-and-sauces">Condiments &amp; Sauces</a></li>
              <li><a href="/shop/frozen-foods">Frozen Foods</a></li>
              <li><a href="/shop/value-packs">Value Packs</a></li>
              <li><a href="/shop/all">All Products</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bg">
        <div className="footer__bg-bus" />
        <div className="footer__bg-bike" />
      </div>

      <div className="footer__bottom">
        <p>
          <strong>
            <a href="https://trendbayds.com" target="_blank" rel="noreferrer" className="footer__brand-link">
              TrendBay Daily Solutions LTD
            </a>
          </strong>{" "}
          &copy; {new Date().getFullYear()} All rights reserved.
        </p>
        <p>
          Designed by{" "}
          <a href="https://cizonet.com" target="_blank" rel="noreferrer" className="footer__brand-link">
            Cizonet Solutions
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
